<template>
	<v-dialog
		v-model="fileMetaEditorDialog"
		fullscreen
		scrollable
		hide-overlay
		transition="dialog-bottom-transition"
		persistent
	>
		<v-card>
			<v-toolbar
				v-shortkey="{
					arrow_left: ['ctrl', 'alt', 'arrowleft'],
					arrow_right: ['ctrl', 'alt', 'arrowright'],
				}"
				@shortkey="toggleTab"
			>
				<v-btn icon @click="closeDialog">
					<v-icon>close</v-icon>
				</v-btn>
				<v-toolbar-title class="toolbar-title-wrapper">
					<div class="stockiest-name-wrapper">
						<div :class="{ expiry: includesExpiryTable }"></div>
						{{ selectedFile.stockistName }} -
						{{ selectedFile.filename }}
						<div
							v-if="'isPythonScriptConvertable' in selectedFile"
							class="badge-circle"
							:class="{
								'green-badge': selectedFile.isPythonScriptConvertable,
							}"
						></div>
					</div>
					<v-btn
						v-if="'isPythonScriptConvertable' in selectedFile"
						color="error"
						outline
						compact
						@click="onDeletePythonScriptConvertableKeyButtonClick(selectedFile)"
					>
						<v-icon>delete</v-icon>
						PYC
					</v-btn>
				</v-toolbar-title>
				<template v-slot:extension>
					<v-tabs v-model="model" slider-color="yellow" align-with-title grow>
						<v-tab v-for="i in tabItems" :key="i.tabId" :href="`#${i.tabId}`">{{
							i.name
						}}</v-tab>
					</v-tabs>
				</template>
			</v-toolbar>
			<v-tabs-items v-model="model">
				<v-tab-item v-for="i in tabItems" :key="i.tabId" :value="i.tabId">
					<v-card flat>
						<v-card-text>
							<component
								@switchTab="goToTab"
								:dataProp="i.props"
								v-bind:is="i.component"
								v-bind="{
									...i.props,
								}"
							/>
						</v-card-text>
					</v-card>
				</v-tab-item>
			</v-tabs-items>
		</v-card>
	</v-dialog>
</template>

<script>
import FileViewer from './fileViewer';
import FileMetaEditor from './fileMetaEditor';
import JSONViewer from './jsonViewer';
import LogViewer from './logViewer';
import mailMetaMixin from '@/mixins/mailMetaMixin';
import orignalFileViewerMixin from '@/mixins/orignalFileViewerMixin';
import mapRejectReworkMixin from '@/mixins/mapRejectReworkMixin';

import { mapGetters, mapActions, mapMutations } from 'vuex';
export default {
	components: {
		FileViewer,
		FileMetaEditor,
		JSONViewer,
		LogViewer,
	},
	mixins: [mailMetaMixin, orignalFileViewerMixin, mapRejectReworkMixin],
	created() {
		// this.model = this.model+'-'+this.selectedFile.uuid;
	},
	data() {
		return {
			tabItems: [
				{
					name: 'Current File',
					tabId: 'tab-1',
					component: 'FileViewer',
					props: {},
				},
				{
					name: 'File Meta',
					tabId: 'tab-2',
					component: 'FileMetaEditor',
					props: {},
				},
				// {
				// 	name: "Parsed",
				// 	tabId: "tab-3",
				// 	component: "JSONViewer",
				// 	props: {
				// 		renderMode: "parsed"
				// 	}
				// },
				{
					name: 'Transformed',
					tabId: 'tab-3',
					component: 'JSONViewer',
					props: {
						renderMode: 'transformed',
					},
				},
				{
					name: 'Logs',
					tabId: 'tab-4',
					component: 'LogViewer',
					props: {},
				},
			],
			model: 'tab-1',
		};
	},
	methods: {
		...mapMutations('fileExtraction', [
			'closeFileMetaDialog',
			'setIncludesExpiryTable',
		]),
		...mapActions('fileExtraction', ['unlockFile']),
		closeDialog() {
			// _id: "5cde85113e4a6e0b2701d6cc"
			this.unlockFile(this.selectedFile._id).then(data => {
				if (!data) {
					this.closeFileMetaDialog();
				}
			});
		},
		toggleTab(event) {
			let currentIndex = Number(this.model.split('-')[1]);
			switch (event.srcKey) {
				case 'arrow_left': {
					if (currentIndex == 1) {
						this.model = 'tab-' + this.tabItems.length;
					} else {
						this.model = 'tab-' + --currentIndex;
					}
					break;
				}

				case 'arrow_right': {
					if (currentIndex == this.tabItems.length) {
						this.model = 'tab-1';
					} else {
						this.model = 'tab-' + ++currentIndex;
					}
					break;
				}
			}
		},
		goToTab(tabId) {
			this.model = tabId;
		},
	},
	mounted() {
		this.setIncludesExpiryTable(false);
	},
	computed: {
		...mapGetters('fileExtraction', [
			'fileMetaEditorDialog',
			'selectedFile',
			'includesExpiryTable',
		]),
	},
};
</script>

<style lang="scss" scoped>
.v-card__text {
	padding: 0px;
}

.expiry {
	height: 15px;
	width: 15px;
	border-radius: 50%;
	background-color: red;
	display: inline-block;
}
</style>
